/* global modForm modUtils */
import { appendFormInput } from '../../../helpers';
/**
 * Add predefined data to the form
 */
export function addRequiredFieldsToContractorForm() {
	const requiredFields = {
		token: '',
		contractorId: '',
		landingPage: modUtils.getLandingPage(),
		elqCookieWrite: '0',
		tcpa: 1,
		tcpaText: modForm.opts.tcpaCopy && modForm.opts.tcpaCopy.length ? Array.from(modForm.opts.tcpaCopy).map(tcpa => tcpa.innerText.trim()) : ''
	};

	Object.keys(requiredFields).forEach((key) => {
		appendFormInput(key, requiredFields[key], true);
	});
}
